// src/utils/docCounter.js
// Reliable doc counter — saves to Supabase + localStorage fallback
import { supabase } from '../lib/supabaseClient.js';
import { userKey } from './storageHelper.js';

export async function incrementDocCount() {
  // Always update localStorage immediately (instant, never fails)
  try {
    const current = parseInt(localStorage.getItem(userKey('qais_docs_generated')) || '0', 10);
    const next = current + 1;
    localStorage.setItem(userKey('qais_docs_generated'), String(next));
  } catch {}

  // Also save to Supabase so it persists across devices/browsers
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    // Upsert — increment the count in the user_profiles table
    const { data: existing } = await supabase
      .from('user_profiles')
      .select('docs_generated')
      .eq('user_id', user.id)
      .single();

    const currentCount = existing?.docs_generated || 0;

    await supabase
      .from('user_profiles')
      .upsert({
        user_id: user.id,
        docs_generated: currentCount + 1,
        updated_at: new Date().toISOString()
      }, { onConflict: 'user_id' });

  } catch (err) {
    // Supabase failed — localStorage already updated so count is safe
    console.log('Supabase sync failed, localStorage count preserved:', err.message);
  }
}

export async function getDocCount() {
  // Try Supabase first (most accurate across devices)
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (user) {
      const { data } = await supabase
        .from('user_profiles')
        .select('docs_generated')
        .eq('user_id', user.id)
        .single();

      if (data?.docs_generated !== undefined) {
        // Sync localStorage with Supabase value
        localStorage.setItem(userKey('qais_docs_generated'), String(data.docs_generated));
        return data.docs_generated;
      }
    }
  } catch {}

  // Fallback to localStorage
  try {
    return parseInt(localStorage.getItem(userKey('qais_docs_generated')) || '0', 10);
  } catch {
    return 0;
  }
}
